import IconLinkedIn from "@/app/(components)/generics/Icons/IconLinkedIn";
import { UStyles } from "@/app/utils/UStyles";
import { Socials } from "@/app/vars/Socials";
import styles from "./FollowUs.module.css";

type Props = {
  dark?: boolean;
};

export default function FollowUs(props: Props) {
  const { dark } = props;

  return (
    <div className={UStyles.classNames(styles.socials, dark ? styles.dark : styles.light)}>
      <a
        className={styles.social}
        href={Socials.LinkedIn}
        target="_blank"
        title="LinkedIn"
        rel="noopener"
      >
        <IconLinkedIn />
      </a>
      {/*
				<a className={ styles.social } href={ Socials.X } target="_blank" title="X">
				<IconX/>
			</a>
			<a className={ styles.social } href={ Socials.Instagram } target="_blank" title="Instagram">
				<IconInstagram/>
			</a>
			<a className={ styles.social } href={ Socials.Tiktok } target="_blank" title="Tiktok">
				<IconTiktok/>
			</a>
			<a className={ styles.social } href={ Socials.Youtube } target="_blank" title="Youtube">
				<IconYoutube/>
			</a>
				* */}
      {/*
			<a className={ styles.social } href={ Socials.Discord } target="_blank" title="Discord">
				<IconDiscord/>
			</a>
			*/}
    </div>
  );
}
